import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Producto.css';

class Producto extends Component {
    constructor(props){
        super(props);
        this.state = {
            marca: '',
            modelo: '',
            tipo: '',
            subtipo: '',
            precio: '',
            descr: '',
            btnText: 'Subir',
            imagen1: '',
            imagen2: '',
            imagen3: '',
            imagen4: '',
            preImg1: '',
            preImg2: '',
            preImg3: '',
            preImg4: '',
            cl: 'insert'
        }
        this.changInput = this.changInput.bind(this);
        if(props.match.params.id !== '0'){
        fetch('https://ebenlovequickpc.com/API/producto.php?cl=one&codigo='+props.match.params.id)
        .then((response => response.json()))
        .then((json) => {
            this.setState({
                marca: json[0].MARCA,
                modelo: json[0].MODELO,
                tipo: json[0].TIPO,
                subtipo: json[0].SUBTIPO,
                precio: json[0].PRECIO,
                descr: json[0].DESCR,
                btnText: 'Actualizar',
                cl: 'update'
            });
        });
        }
    }

    changInput(e){
        switch(e.target.name){
            case 'marca':
                this.setState({
                    marca: e.target.value
                });
            break;
            case 'modelo':
                this.setState({
                    modelo: e.target.value
                });
            break;
            case 'tipo':
                this.setState({
                    tipo: e.target.value
                });
            break;
            case 'subtipo':
                this.setState({
                    subtipo: e.target.value
                });
            break;
            case 'precio':
                this.setState({
                    precio: e.target.value
                });
            break;
            case 'descr':
                this.setState({
                    descr: e.target.value
                });
            break;
            case 'imagen1':
                this.setState({
                    preImg1: URL.createObjectURL(e.target.files[0]),
                    imagen1: e.target.files[0]
                })
            break;
            case 'imagen2':
                this.setState({
                    preImg2: URL.createObjectURL(e.target.files[0]),
                    imagen2: e.target.files[0]
                })
            break;
            case 'imagen3':
                this.setState({
                    preImg3: URL.createObjectURL(e.target.files[0]),
                    imagen3: e.target.files[0]
                })
            break;
            case 'imagen4':
                this.setState({
                    preImg4: URL.createObjectURL(e.target.files[0]),
                    imagen4: e.target.files[0]
                })
            break;
            default:
            break;
        }
    }


    addProd(e){
        e.preventDefault();
        this.setState({
            btnText: 'SUBIENDO'
        })
       var formData = new FormData();
        formData.append('marca', this.state.marca);
        formData.append('modelo', this.state.modelo);
        formData.append('tipo', this.state.tipo);
        formData.append('precio', this.state.precio);
        formData.append('descr', this.state.descr);
        formData.append('img1', this.state.imagen1);
        formData.append('img2', this.state.imagen2);
        formData.append('img3', this.state.imagen3);
        formData.append('img4', this.state.imagen4);
        formData.append('cl', this.state.cl);
        formData.append('codigo_art', this.props.match.params.id);
        formData.append('subtipo', this.state.subtipo);
        fetch('httpS://ebenlovequickpc.com/API/addProd.php',{
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then((json) => {
            console.log(json)
            if (!("Notification" in window)) {
                alert("This browser does not support desktop notification");
              }else if (Notification.permission === "granted") {
                
                var notification = new Notification("COMPLETADO");
              }else if (Notification.permission !== 'denied') {
                Notification.requestPermission(function (permission) {
                  if (permission === "granted") {
                    var notification = new Notification("COMPLETADO");
                  }
                });
              }
              window.location.href = `/productos`;
        })
    }
  render() {
    return (
        <div className="w3-container">
            <h5>Producto</h5>
            <form className="w3-container w3-white w3-card w3-padding" onSubmit={this.addProd.bind(this)}>
                <div className="w3-half w3-padding">
                    <label className="w3-text-grey" htmlFor='marca'>Marca</label>
                    <input className="w3-input w3-border" type="text" name='marca' value={this.state.marca} onChange={this.changInput} />
                </div>
                <div className="w3-half w3-padding">
                    <label className="w3-text-grey" htmlFor='modelo'>Modelo</label>
                    <input className="w3-input w3-border" type="text" name='modelo' value={this.state.modelo} onChange={this.changInput} />
                </div>
                <div className="w3-half w3-padding">
                <label className="w3-text-grey" htmlFor='tipo'>Categoría</label>
                <select className="w3-select w3-border" name='tipo' onChange={this.changInput}>
                    <option disabled selected>Tipo</option>
                    <option value="LT">Laptop</option>
                    <option value="DT">Desktop</option>
                    <option value="PH">Phone</option>
                    <option value="TA">Table</option>
                    <option value="WS">Workstation</option>
                    <option value="AC">Accesorio</option>
                </select>
                </div>
                {(this.state.tipo === 'AC') && 
                    <div className="w3-half w3-padding">
                        <label className="w3-text-grey" htmlFor='subtipo'>SubCategoría</label>
                        <select className="w3-select w3-border" name='subtipo' onChange={this.changInput}>
                            <option disabled selected>Tipo</option>
                            <option value="MN">Monitores</option>
                            <option value="MC">Mochilas</option>
                            <option value="TM">Teclados y Mouses</option>
                            <option value="AV">Audio y Video</option>
                            <option value="DP">Docks y Puertos</option>
                            <option value="VG">Videografía</option>
                            <option value="AM">Almacenamientos</option>
                            <option value="BC">Baterías y Cargadores</option>
                            <option value="CA">Cables y Adaptadores</option>
                            <option value="PY">Proyectores</option>
                            <option value="MS">Mesas</option>
                            <option value="IM">Impresoras</option>
                            <option value="JG">Juegos</option>
                            <option value="CC">CCTV</option>
                            <option value="OT">Otros</option>
                        </select>
                    </div> 
                }
                <div className="w3-container w3-padding">
                    <label className="w3-text-grey" htmlFor='precio'>Precio</label>
                    <input className="w3-input w3-border" type="text"  value={this.state.precio} name='precio' onChange={this.changInput} />
                </div>
                <div className="w3-container w3-padding">
                    <label className="w3-text-grey" htmlFor='descripcion'>Descripción</label>
                    <textarea className="w3-input w3-border" name='descr'  value={this.state.descr} onChange={this.changInput}></textarea>
                </div>
                <div className="w3-container w3-padding">
                    <span className="w3-text-grey" htmlFor='descripcion'>Imagen</span> 
                    <div className='w3-row'>
                        <div className='w3-col l3'>
                            <label htmlFor='imagen1' style={{backgroundImage:`url(${this.state.preImg1})`,backgroundSize:'cover'}}> Subir Portada</label>
                            <input id='imagen1' type="file" accept=".png, .jpg, .jpeg" name="imagen1" onChange={this.changInput}/>
                        </div>
                        <div className='w3-col l3'>
                            <label htmlFor='imagen2' style={{backgroundImage:`url(${this.state.preImg2})`,backgroundSize:'cover'}}> Subir Imagen</label>
                            <input id='imagen2' type="file" accept=".png, .jpg, .jpeg" name="imagen2" onChange={this.changInput} />
                        </div>
                        <div className='w3-col l3'>
                            <label htmlFor='imagen3' style={{backgroundImage:`url(${this.state.preImg3})`,backgroundSize:'cover'}}> Subir Imagen</label>
                            <input id='imagen3' type="file" accept=".png, .jpg, .jpeg" name="imagen3" onChange={this.changInput} />
                        </div>
                        <div className='w3-col l3'>
                            <label htmlFor='imagen4' style={{backgroundImage:`url(${this.state.preImg4})`,backgroundSize:'cover'}}> Subir Descripcion</label>
                            <input id='imagen4' type="file" accept=".png, .jpg, .jpeg" name="imagen4" onChange={this.changInput} />
                        </div>
                    </div>
                </div>
                <div className='w3-center w3-container w3-margin' style={{marginTop: '25px'}}>
                    <button className="w3-button w3-black w3-round">{this.state.btnText}</button>
                    <Link to={`/productos`} style={{marginLeft: '10px'}} className="w3-button w3-black w3-round">Cancelar</Link>
                </div>
            </form> 
        </div>
    );
  }
}

export default Producto;


// WEBPACK FOOTER //
// ./src/Productos/Producto.js